<div class="card" *ngIf="combustivel">
  <div class="card-header">
    <h2>{{ combustivel.descricaoCombustivel}}</h2>
  </div>

  <div class="card-body">
    <div class="row justify-content-center preco1">
      <div class="col-3 centralizado">
        <h3 class="text-left comb-titulo">{{combustivel.combustivel.precos.precoUnitario.length > 0 ?
          combustivel.combustivel.precos.precoUnitario[0].titulo : 'Sem descricao' }}</h3>
        <p class="lable-preco text-left comb-descricao">{{combustivel.combustivel.precos.precoUnitario.length > 0 ?
          combustivel.combustivel.precos.precoUnitario[0].descricao : 'Sem descricao' }}</p>
      </div>

      <div class="col-3 centralizado">
        <svg mat-raised-button
          matTooltip="Alteração: {{  combustivel.combustivel.datInicio  | date: 'dd/MM/yyy' || 'Sem Info' + '\n' }}
                                                Situação: {{ combustivel.combustivel.dscStatusAcordo || 'Sem Info' + '\n' }}
                                                Desde: {{ combustivel.combustivel.datCadastro | date: 'dd/MM/yyy' || 'Sem Info' }}"
          aria-label="Button that displays a tooltip when focused or hovered over" matTooltipClass="my-tooltip"
          matTooltipPosition="after" type="button" data-container="body" data-toggle="popover" data-trigger="hover"
          xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor"
          class="bi bi-info-circle-fill comb-informacao" viewBox="0 0 16 16">
          <path
            d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z" />
        </svg>
      </div>

      <div class="col-4">
        <div class="input-group mb-3">
          <span class="input-group-text">R$</span>
          <input class="form-control form-control-lg" step="0.01" type="text" readonly
            [ngModel]="combustivel.combustivel.precos.precoUnitario[0].preco | number:'1.2-2'"
            [readonly]="combustivel.combustivel.precos.precoUnitario[0].somenteLeitura">
            <button 
          
            class="btn btn-terceary" (click)="alterarValor(combustivel, 'precoUnitario')">
              <i class="fa fa-edit" aria-hidden="true"></i>&nbsp;&nbsp;Alterar
            </button>

        </div>
        <p class="situacao-text alt-margin-bottom"
          *ngIf="combustivel.combustivel.precos.precoUnitario[0].id == 'precoNegociado'">
          Situação: <b>{{combustivel.combustivel.dscStatusAcordo || "Informação ausente no momento"}}</b>
        </p>
      </div>




    </div>

    <div class="row justify-content-center">
      <div class="col-3 centralizado">
        <h3 class="text-left comb-titulo">{{combustivel.combustivel.precos.precoNegociado.length > 0 ?
          combustivel.combustivel.precos.precoNegociado[0].titulo : 'Sem descricao' }}</h3>
        <p class="lable-preco text-left comb-descricao">{{combustivel.combustivel.precos.precoNegociado.length > 0 ?
          combustivel.combustivel.precos.precoNegociado[0].descricao : 'Sem descricao' }}</p>
      </div>

      <div class="col-3 centralizado">
        <svg mat-raised-button
          matTooltip="Alteração: {{  combustivel.combustivel.datInicio  | date: 'dd/MM/yyy' || 'Sem Info' + '\n' }}
                                                Situação: {{ combustivel.combustivel.dscStatusAcordo || 'Sem Info' + '\n' }}
                                                Desde: {{ combustivel.combustivel.datCadastro | date: 'dd/MM/yyy' || 'Sem Info' }}"
          aria-label="Button that displays a tooltip when focused or hovered over" matTooltipClass="my-tooltip"
          matTooltipPosition="after" type="button" data-container="body" data-toggle="popover" data-trigger="hover"
          xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor"
          class="bi bi-info-circle-fill comb-informacao" viewBox="0 0 16 16">
          <path
            d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z" />
        </svg>
      </div>

      <div class="col-4">


        <div class="input-group mb-3">
          <span class="input-group-text">R$</span>
          <input class="form-control form-control-lg" type="text" step="0.01" readonly
            [ngModel]="combustivel.combustivel.precos.precoNegociado[0].preco | number:'1.2-2'"
            [readonly]="combustivel.combustivel.precos.precoNegociado[0].somenteLeitura">

            <button 
            [disabled]="!combustivel.disponivelParaVenda"
            class="btn btn-terceary btn-lg" (click)="alterarValor(combustivel, 'precoNegociado')">
              <i class="fa fa-edit" aria-hidden="true"></i>&nbsp;&nbsp;Alterar
            </button>
        </div>


        <p class="situacao-text alt-margin-bottom">
          Situação: <b>{{combustivel.combustivel.dscStatusAcordo || "Informação ausente no momento"}}</b>
        </p>
      </div>

  
    </div>

    <div class="row justify-content-center" *ngIf="combustivel.redeEspecial">
      <div class="col-3 centralizado">
        <h3 class="text-left comb-titulo">{{combustivel.combustivel.precos.precoRedeEspecial.length > 0 ?
          combustivel.combustivel.precos.precoRedeEspecial[0].titulo : 'Sem descricao' }}</h3>
        <p class="lable-preco text-left comb-descricao">{{combustivel.combustivel.precos.precoRedeEspecial.length > 0 ?
          combustivel.combustivel.precos.precoRedeEspecial[0].descricao : 'Sem descricao' }}</p>
      </div>
      <div class="col-3 centralizado">
        <svg mat-raised-button
          matTooltip="Dúvidas sobre a Rede Especial, favor entrar em contato com Gabriel (11 992071357)"
          aria-label="Button that displays a tooltip when focused or hovered over" matTooltipClass="my-tooltip"
          matTooltipPosition="after" type="button" data-container="body" data-toggle="popover" data-trigger="hover"
          xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor"
          class="bi bi-info-circle-fill comb-informacao" viewBox="0 0 16 16">
          <path
            d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z" />
        </svg>
      </div>
      <!-- <pre>

        {{combustivel.combustivel.precos | json}}
      </pre> -->
      <div class="col-4">

        <div class="input-group mb-3">
          <span class="input-group-text">R$</span>
          <input class="form-control form-control-lg" type="text" readonly step="0.01"
            [ngModel]="combustivel.combustivel.precos.precoRedeEspecial[0].preco | number:'1.2-2'"
            [readonly]="combustivel.combustivel.precos.precoRedeEspecial[0].somenteLeitura">

            <button 
            [disabled]="!combustivel.disponivelParaVenda"
            class="btn btn-terceary btn-lg" (click)="alterarValor(combustivel, 'precoRedeEspecial')">
              <i class="fa fa-edit" aria-hidden="true"></i>&nbsp;&nbsp;Alterar
            </button>
        </div>
        <p class="situacao-text alt-margin-bottom">
          Situação: <b>{{combustivel.combustivel.dscStatusAcordo || "Informação ausente no momento"}}</b>
        </p>
      </div>
   

    </div>
    <div class="col-md-4 offset-md-8 pt-5 ">
      <div class="d-flex justify-content-center">
        <strong>
          Disponível para vendas?
        </strong>
      </div>

      <div class="form-check form-switch d-flex justify-content-center pt-1">
        <input class="form-check-input" 
        [disabled]="!combustivel.disponivelParaVenda" id="customCheck" type="checkbox"
          (change)="handleHabilitarCombustivel($event, combustivel)" [checked]=combustivel.disponivelParaVenda>
      </div>
    </div>
  </div>

</div>